import { render, staticRenderFns } from "./ScrollingFooter.vue?vue&type=template&id=9c33a98c&scoped=true&"
import script from "./ScrollingFooter.vue?vue&type=script&lang=ts&"
export * from "./ScrollingFooter.vue?vue&type=script&lang=ts&"
import style0 from "./ScrollingFooter.vue?vue&type=style&index=0&id=9c33a98c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c33a98c",
  null
  
)

export default component.exports